import { render } from "./ChapPass.vue?vue&type=template&id=0057ac29&scoped=true"
import script from "./ChapPass.vue?vue&type=script&lang=js"
export * from "./ChapPass.vue?vue&type=script&lang=js"

import "./ChapPass.vue?vue&type=style&index=0&id=0057ac29&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0057ac29"]])

export default __exports__